<script setup lang="ts">
  import type { IntegrationProvider } from '@stuut/api-sdk/models';
  import type { Integration } from '@stuut/api/models';

  interface Props {
    integration: Integration | IntegrationProvider;
  }

  defineProps<Props>();
</script>

<template>
  <!--  @vue-ignore -->
  <img
    v-if="integration.name !== 'file-sync'"
    :src="integration.logo_square || integration.logoSquare"
    class="size-8 object-contain"
  />

  <div v-else class="flex align-center justify-center items-center text-center size-8">
    <i class="fa fas fa-file-export mx-auto text-center text-base inline-block" />
  </div>
</template>

<style scoped></style>
